/* tslint:disable */
/* eslint-disable */
/**
 * Price and Capacity Track & automatic reserve Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AddTrainPreSaleTrackingRequest } from '../model';
/**
 * WebEngageApiApiWebEngagePreSalePost - axios parameter creator
 * 
 * @param {AddTrainPreSaleTrackingRequest} [addTrainPreSaleTrackingRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function WebEngageApiApiWebEngagePreSalePostAxiosParamCreator (addTrainPreSaleTrackingRequest?: AddTrainPreSaleTrackingRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/WebEngage/PreSale`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addTrainPreSaleTrackingRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiWebEngagePreSalePost operation in WebEngageApi.
 * @export
 * @interface WebEngageApiApiWebEngagePreSalePostRequest
 */
export interface WebEngageApiApiWebEngagePreSalePostRequest {
    /**
     * 
     * @type {AddTrainPreSaleTrackingRequest}
     * @memberof WebEngageApiApiWebEngagePreSalePost
     */
    readonly addTrainPreSaleTrackingRequest?: AddTrainPreSaleTrackingRequest
}

/**
* 
* @param {WebEngageApiApiWebEngagePreSalePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function WebEngageApiApiWebEngagePreSalePost(requestParameters: WebEngageApiApiWebEngagePreSalePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await WebEngageApiApiWebEngagePreSalePostAxiosParamCreator(requestParameters.addTrainPreSaleTrackingRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
